// import { Swiper } from 'swiper';
// import 'swiper/swiper.min.css';
// import 'swiper/css/scrollbar';

/* eslint-disable no-use-before-define */
export default (element) => {
  const init = () => {
    element.searchToggle = element.querySelectorAll('[data-search-toggle]');
    element.searchContainer = element.querySelector('[data-search-wrap]');
    element.accountContainer = element.querySelector(
      '.header__account--container',
    );
    element.cartToggle = element.querySelector('[data-cart-open]');
    element.mobileMenuToggle = element.querySelector('[data-container="menu"]');
    element.accountLink = element.querySelector('[data-link="account"]');
    toggleSearch();
    headerTransition();
    promobarHandle();
    minicartHandle();
    mobileMenuHandle();
  };

  // const handleSearchContainerScroll = () => {
  //   const swiper = new Swiper('[data-search-desktop]', {
  //     slidesPerView: 1.05,
  //     spaceBetween: 8,
  //     breakpoints: {
  //       1024: {
  //         slidesPerView: 2.1,
  //       },
  //     },
  //     pagination: {
  //       el: '[data-search-scroll-bar]',
  //       type: 'progressbar',
  //     },
  //   });
  // };

  const promobarHandle = () => {
    const promotionalBarElement = document.querySelector(
      '[data-section="promotional-bar"]',
    );
    const headerElement = document.querySelector(
      '.bg-transparent[data-section="header"]',
    )
      ? document.querySelector('.bg-transparent[data-section="header"]')
      : document.querySelector('[data-section="header"]');

    if (promotionalBarElement) {
      headerElement.classList.add('top-[34px]');
      headerElement.classList.add('tablet:top-[39px]');
    } else {
      headerElement.classList.add('-top-px');
    }
  };

  const minicartHandle = () => {
    const openCartEvent = new CustomEvent('cart:open');
    element.cartToggle.addEventListener('click', () => {
      document.dispatchEvent(openCartEvent);
    });
  };

  const mobileMenuHandle = () => {
    const mobileMenuBackdrop = element.querySelector(
      '[data-panel]+.backdrop-overlay',
    );
    document.addEventListener('status:user:login', () => {
      element.accountLink.innerText = window.TMW.Strings.customer.viewAccount;
    });
    element.accountLink.addEventListener('click', () => {
      mobileMenuBackdrop?.click();
    });
    element.mobileMenuToggle.addEventListener('click', () => {
      let label = window.TMW.Strings.customer.signIn;
      if (window.StatusInitData?.customerId) {
        label = window.TMW.Strings.customer.viewAccount;
      }
      element.accountLink.innerText = label;
    });
  };

  const headerTransition = () => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        document.body.classList.add('header-scrolled');
      } else {
        document.body.classList.remove('header-scrolled');
      }
    });
  };

  /**
   * Search init
   * @private
   */
  const toggleSearch = () => {
    element.searchToggle.forEach((target) => {
      target.addEventListener('click', (event) => {
        event.preventDefault();
        element.searchContainer.dataset.searchStatus = element.searchContainer.dataset.searchStatus === 'true'
          ? 'false'
          : 'true';
        if (element.searchContainer.dataset.searchStatus === 'true') {
          document.querySelector('body')?.classList?.add('disable-scroll');
          element.searchContainer.classList.add('!flex');
          element.searchContainer.querySelector("[name='search']").focus();
          // handleSearchContainerScroll();
        } else {
          document.querySelector('body')?.classList?.remove('disable-scroll');
          element.searchContainer.classList.remove('!flex');
        }
      });
    });
  };

  init();
};
